import { DATA_SOURCES } from '@/config/constants';
import { useEntity } from 'utils/hooks/api';
import { filterClusters, filterNames, filterParentName } from 'utils/filters';
import GoogleRelatedSectionTable from '../GoogleRelatedTable/GoogleRelatedSectionTable';
import { TableClusterNameCell } from 'components/DataVis/DataTable/styledComponents';
import { createDefaultColumns } from '../DataTable/utils';

function CatFiveAffinitiesTable({
    categoryId,
    brandId,
    countryId,
    controller = null,
    handleFilter = {
        cluster: filterClusters,
        parentName: filterParentName,
        name: filterNames,
    },
    sortParamKey,
    ...restProps
}) {
    const relatedItem = useEntity({
        id: categoryId || brandId,
        entityType: categoryId ? 'categories' : 'brands',
        dataSource: DATA_SOURCES.GOOGLE,
    }).data;
    const relatedName =
        relatedItem && relatedItem.name ? relatedItem.name : null;
    const getColumnsConfig = (visibleOrderedMetrics) => {
        const columnsConfig = createDefaultColumns([
            'name',
            'parentName',
            ...visibleOrderedMetrics,
        ]);
        columnsConfig[0].label = relatedName ? `a-z: ${relatedName}` : 'a-z';
        columnsConfig[0].formatCell = ({ value, row }) => (
            <TableClusterNameCell
                cluster={row.cluster}
                fetching={row.fetchingData}
                name={value}
                relatedName={relatedName}
            />
        );
        return columnsConfig;
    };
    return (
        <GoogleRelatedSectionTable
            paginateBy="affinities"
            categories={categoryId}
            brands={brandId}
            countries={countryId}
            controller={controller}
            getColumnsConfig={getColumnsConfig}
            handleFilter={handleFilter}
            sortParamKey={sortParamKey}
            rowHeight={60}
            {...restProps}
        />
    );
}

export default CatFiveAffinitiesTable;
